export default function ServicesSection() {
  const services = [
    {
      icon: 'ri-file-paper-2-line',
      title: 'チラシ作成',
      description: 'ヒアリングを元に、チラシやデザイン作成します。ご希望で印刷業者への入稿も承ります',
      price: '¥4,500',
      priceNote: '(デザイン片面)',
      image: 'https://static.readdy.ai/image/a94bf782443eac1605091ed034a69659/fb33d57f50beaaa702835a251c8b4cba.jpeg',
      features: [
        'ヒアリングに基づくデザイン',
        '修正対応',
        '印刷業者への入稿代行可能'
      ]
    },
    {
      icon: 'ri-shopping-cart-line',
      title: 'ネットショップ作成',
      description: 'BASEを用いたネットショップサイト制作。商品登録や各種設定もご希望で承ります。',
      price: '¥20,000〜',
      priceNote: '',
      image: 'https://static.readdy.ai/image/a94bf782443eac1605091ed034a69659/60356394774d8ea6639961b337ffa5ad.png',
      features: [
        'BASEプラットフォーム使用',
        'サイトデザイン・構築',
        '商品登録代行',
        '各種設定サポート'
      ]
    },
    {
      icon: 'ri-smartphone-line',
      title: '業務改善アプリ制作',
      description: '在庫管理アプリやオーダー受付アプリ、オリジナルタスクメモアプリなど、お客様の業務に応じたミニアプリを作成します',
      price: '¥38,000〜',
      priceNote: '',
      image: 'https://static.readdy.ai/image/a94bf782443eac1605091ed034a69659/11a793f9475d49110526da9402a6b89c.png',
      features: [
        '在庫管理アプリ',
        'オーダー受付アプリ',
        'カスタムタスク管理',
        '業務効率化ツール'
      ]
    }
  ];

  return (
    <section id="services" className="py-16 sm:py-24 lg:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-8">
        <div className="text-center mb-12 sm:mb-16 space-y-4">
          <h2 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-[#2C2C2C]">
            制作サービスの提供
          </h2>
          <p className="text-base sm:text-lg text-[#757575] max-w-3xl mx-auto leading-relaxed">
            お客様のビジネスに合わせた、柔軟なデジタル制作サービスをご提供します
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div 
              key={index}
              className="bg-gradient-to-br from-[#FAF0E6] to-white rounded-3xl overflow-hidden shadow-lg hover:shadow-2xl transition-all hover:scale-105"
            >
              <div className="relative h-64 overflow-hidden">
                <img 
                  alt={service.title} 
                  className="w-full h-full object-cover object-top" 
                  src={service.image}
                />
                <div className="absolute top-4 left-4 w-14 h-14 flex items-center justify-center bg-white rounded-full shadow-lg">
                  <i className={`${service.icon} text-3xl text-[#66BB6A]`}></i>
                </div>
              </div>

              <div className="p-8 space-y-6">
                <div>
                  <h3 className="text-2xl font-bold text-[#2C2C2C] mb-3">
                    {service.title}
                  </h3>
                  <p className="text-base text-[#757575] leading-relaxed">
                    {service.description}
                  </p>
                </div>

                <div className="space-y-3">
                  {service.features.map((feature, idx) => (
                    <div key={idx} className="flex items-start gap-2">
                      <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                        <i className="ri-check-line text-lg text-[#66BB6A]"></i>
                      </div>
                      <span className="text-sm text-[#2C2C2C]">{feature}</span>
                    </div>
                  ))}
                </div>

                <div className="pt-4 border-t border-[#E0E0E0]">
                  <div className="text-3xl font-bold text-[#66BB6A]">
                    {service.price}
                  </div>
                  {service.priceNote && (
                    <div className="text-sm text-[#757575] mt-1">
                      {service.priceNote}
                    </div>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <div className="inline-block bg-gradient-to-r from-[#E8F5E9] to-[#C8E6C9] rounded-2xl px-8 py-6">
            <p className="text-base sm:text-lg text-[#2C2C2C] leading-relaxed">
              <i className="ri-information-line text-xl text-[#66BB6A] mr-2"></i>
              ※料金は全て税込価格となります
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
